import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  ADD_ICON_IMAGE,
  CloseImage,
  DELETE_CARD_MODAL,
  Header,
  ButtonContainer
} from '../../screens/manage-payment/manage-payment.style';
import CommonButton from '../common-button/CommonButton';
import { CLOSE_HEAVY_ICON } from '@Images';
import {
  EVENT_ROUTE_KEYS,
  EventItemSection,
  EventNamesV2,
  FLOW_TYPE
} from '@Utils/events/eventsConstants';
import { logEventV2 } from '@Utils/events/logUserEvents';

const DeleteCard = ({ card, template, onClose, removeCard }) => {
  const [showSpinner, setShowSpinner] = useState(false);

  const logEvent = (ctaName) => {
    const { card_brand, card_number, card_type } = card;

    const eventProperty = {
      section: EventItemSection.LIST,
      pageName: EVENT_ROUTE_KEYS.ManagePaymentOptions,
      ctaName,
      card_brand,
      card_number,
      card_type,
      flowType: FLOW_TYPE.MANAGE_PAYMENT_OPTIONS
    };
    logEventV2(EventNamesV2.ITEM_CLICKED, eventProperty);
  };
  return (
    <DELETE_CARD_MODAL>
      <CloseImage style={{ paddingTop: '35px', paddingRight: '25px' }}>
        <ADD_ICON_IMAGE
          src={CLOSE_HEAVY_ICON}
          onClick={() => {
            logEvent('Close');
            onClose(false);
          }}
          style={{
            height: '21px',
            cursor: 'pointer',
            paddingRight: '20px'
          }}
        />
      </CloseImage>
      <div className="text-container">
        <Header>{template.modal.header}</Header>
        <Header fontSize="16px" $paddingTop="30px">
          {template.modal.subHeader(card.card_number, card.card_brand)}
        </Header>
      </div>
      <ButtonContainer paddingLeft={'50px'} paddingRight={'50px'}>
        <CommonButton
          text={template.modal.rmvText}
          loaderHeight={40}
          isLoading={showSpinner}
          disabled={showSpinner}
          onClick={() => {
            logEvent('Deleted');
            removeCard(card.remitter_card_id, onClose, setShowSpinner);
          }}
        />
      </ButtonContainer>
      <div className="close-text">
        <CommonButton
          type="link"
          text="Cancel"
          onClick={() => {
            logEvent('Close');
            onClose(false);
          }}
        />
      </div>
    </DELETE_CARD_MODAL>
  );
};

DeleteCard.propTypes = {
  card: PropTypes.object,
  template: PropTypes.object,
  onClose: PropTypes.func,
  removeCard: PropTypes.func
};

export default DeleteCard;
